import { render } from "./SuspendDealModal.vue?vue&type=template&id=5e91949e&ts=true"
import script from "./SuspendDealModal.vue?vue&type=script&lang=ts"
export * from "./SuspendDealModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__